<div class="mt-10 text-lg text-center">
    <hero-icon name="exclamation" type="outline" class="w-6 h-6 inline text-rag-amber"></hero-icon>
    No data yet
</div>
